// extracted by mini-css-extract-plugin
export default {"footerBackground":"BlackFriday2025Paywall_footerBackground__k1UIO"};